"use client";

import React, { useCallback, useRef, useState } from "react";
import dynamic from "next/dynamic";
import { useJsApiLoader } from "@react-google-maps/api";

const Autocomplete = dynamic(
  () => import("@react-google-maps/api").then((mod) => mod.Autocomplete),
  { ssr: false }
);

const libraries = ["places"];

export default function GoogleAutocomplete({
  onPlaceChanged,
  placeholder = "Enter address",
  className = "",
}) {
  const autocompleteRef = useRef(null);
  const [inputValue, setInputValue] = useState("");

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBk6F6JK68CJ-eY7tGLq45mbiju63EwUps",
    libraries,
  });

  const handleOnLoad = useCallback((autocompleteInstance) => {
    autocompleteRef.current = autocompleteInstance;
  }, []);

  const handlePlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      onPlaceChanged(place);
    }
  };

  if (loadError) return <p>Failed to load Google Maps API</p>;
  if (!isLoaded) return null;

  return (
    <Autocomplete onLoad={handleOnLoad} onPlaceChanged={handlePlaceChanged}>
      <input
        type="text"
        className={className}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={placeholder}
      />
    </Autocomplete>
  );
}
